export default __webpack_public_path__ + "513419aac5858ba5c48185528bda449e.svg";